{
    "type": "object",
    "required": [
        "metadata",
        "nodes",
        "sources",
        "macros",
        "docs",
        "exposures",
        "metrics",
        "groups",
        "selectors"
    ],
    "properties": {
        "metadata": {
            "$ref": "#/definitions/ManifestMetadata",
            "description": "Metadata about the manifest"
        },
        "nodes": {
            "type": "object",
            "additionalProperties": {
                "oneOf": [
                    {
                        "$ref": "#/definitions/AnalysisNode"
                    },
                    {
                        "$ref": "#/definitions/SingularTestNode"
                    },
                    {
                        "$ref": "#/definitions/HookNode"
                    },
                    {
                        "$ref": "#/definitions/ModelNode"
                    },
                    {
                        "$ref": "#/definitions/RPCNode"
                    },
                    {
                        "$ref": "#/definitions/SqlNode"
                    },
                    {
                        "$ref": "#/definitions/GenericTestNode"
                    },
                    {
                        "$ref": "#/definitions/SnapshotNode"
                    },
                    {
                        "$ref": "#/definitions/SeedNode"
                    }
                ]
            },
            "description": "The nodes defined in the dbt project and its dependencies"
        },
        "sources": {
            "type": "object",
            "additionalProperties": {
                "$ref": "#/definitions/SourceDefinition"
            },
            "description": "The sources defined in the dbt project and its dependencies"
        },
        "macros": {
            "type": "object",
            "additionalProperties": {
                "$ref": "#/definitions/Macro"
            },
            "description": "The macros defined in the dbt project and its dependencies"
        },
        "docs": {
            "type": "object",
            "additionalProperties": {
                "$ref": "#/definitions/Documentation"
            },
            "description": "The docs defined in the dbt project and its dependencies"
        },
        "exposures": {
            "type": "object",
            "additionalProperties": {
                "$ref": "#/definitions/Exposure"
            },
            "description": "The exposures defined in the dbt project and its dependencies"
        },
        "metrics": {
            "type": "object",
            "additionalProperties": {
                "$ref": "#/definitions/Metric"
            },
            "description": "The metrics defined in the dbt project and its dependencies"
        },
        "groups": {
            "type": "object",
            "additionalProperties": {
                "$ref": "#/definitions/Group"
            },
            "description": "The groups defined in the dbt project"
        },
        "selectors": {
            "type": "object",
            "description": "The selectors defined in selectors.yml"
        },
        "disabled": {
            "oneOf": [
                {
                    "type": "object",
                    "additionalProperties": {
                        "type": "array",
                        "items": {
                            "oneOf": [
                                {
                                    "$ref": "#/definitions/AnalysisNode"
                                },
                                {
                                    "$ref": "#/definitions/SingularTestNode"
                                },
                                {
                                    "$ref": "#/definitions/HookNode"
                                },
                                {
                                    "$ref": "#/definitions/ModelNode"
                                },
                                {
                                    "$ref": "#/definitions/RPCNode"
                                },
                                {
                                    "$ref": "#/definitions/SqlNode"
                                },
                                {
                                    "$ref": "#/definitions/GenericTestNode"
                                },
                                {
                                    "$ref": "#/definitions/SnapshotNode"
                                },
                                {
                                    "$ref": "#/definitions/SeedNode"
                                },
                                {
                                    "$ref": "#/definitions/SourceDefinition"
                                },
                                {
                                    "$ref": "#/definitions/Exposure"
                                },
                                {
                                    "$ref": "#/definitions/Metric"
                                }
                            ]
                        }
                    }
                },
                {
                    "type": "null"
                }
            ],
            "description": "A mapping of the disabled nodes in the target"
        },
        "parent_map": {
            "oneOf": [
                {
                    "type": "object",
                    "additionalProperties": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        }
                    }
                },
                {
                    "type": "null"
                }
            ],
            "description": "A mapping from\u00a0child nodes to their dependencies"
        },
        "child_map": {
            "oneOf": [
                {
                    "type": "object",
                    "additionalProperties": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        }
                    }
                },
                {
                    "type": "null"
                }
            ],
            "description": "A mapping from parent nodes to their dependents"
        },
        "group_map": {
            "oneOf": [
                {
                    "type": "object",
                    "additionalProperties": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        }
                    }
                },
                {
                    "type": "null"
                }
            ],
            "description": "A mapping from group names to their nodes"
        }
    },
    "additionalProperties": false,
    "description": "WritableManifest(metadata: dbt.contracts.graph.manifest.ManifestMetadata, nodes: Mapping[str, Union[dbt.contracts.graph.nodes.AnalysisNode, dbt.contracts.graph.nodes.SingularTestNode, dbt.contracts.graph.nodes.HookNode, dbt.contracts.graph.nodes.ModelNode, dbt.contracts.graph.nodes.RPCNode, dbt.contracts.graph.nodes.SqlNode, dbt.contracts.graph.nodes.GenericTestNode, dbt.contracts.graph.nodes.SnapshotNode, dbt.contracts.graph.nodes.SeedNode]], sources: Mapping[str, dbt.contracts.graph.nodes.SourceDefinition], macros: Mapping[str, dbt.contracts.graph.nodes.Macro], docs: Mapping[str, dbt.contracts.graph.nodes.Documentation], exposures: Mapping[str, dbt.contracts.graph.nodes.Exposure], metrics: Mapping[str, dbt.contracts.graph.nodes.Metric], groups: Mapping[str, dbt.contracts.graph.nodes.Group], selectors: Mapping[str, Any], disabled: Optional[Mapping[str, List[Union[dbt.contracts.graph.nodes.AnalysisNode, dbt.contracts.graph.nodes.SingularTestNode, dbt.contracts.graph.nodes.HookNode, dbt.contracts.graph.nodes.ModelNode, dbt.contracts.graph.nodes.RPCNode, dbt.contracts.graph.nodes.SqlNode, dbt.contracts.graph.nodes.GenericTestNode, dbt.contracts.graph.nodes.SnapshotNode, dbt.contracts.graph.nodes.SeedNode, dbt.contracts.graph.nodes.SourceDefinition, dbt.contracts.graph.nodes.Exposure, dbt.contracts.graph.nodes.Metric]]]], parent_map: Optional[Dict[str, List[str]]], child_map: Optional[Dict[str, List[str]]], group_map: Optional[Dict[str, List[str]]])",
    "definitions": {
        "ManifestMetadata": {
            "type": "object",
            "required": [],
            "properties": {
                "dbt_schema_version": {
                    "type": "string",
                    "default": "https://schemas.getdbt.com/dbt/manifest/v9.json"
                },
                "dbt_version": {
                    "type": "string",
                    "default": "1.6.0a1"
                },
                "generated_at": {
                    "type": "string",
                    "format": "date-time",
                    "default": "2023-04-21T11:09:06.496436Z"
                },
                "invocation_id": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ],
                    "default": "c4b245be-8edb-4ad7-ba54-9337ce594f5d"
                },
                "env": {
                    "type": "object",
                    "additionalProperties": {
                        "type": "string"
                    },
                    "default": {}
                },
                "project_id": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ],
                    "description": "A unique identifier for the project"
                },
                "user_id": {
                    "oneOf": [
                        {
                            "type": "string",
                            "pattern": "[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}"
                        },
                        {
                            "type": "null"
                        }
                    ],
                    "description": "A unique identifier for the user"
                },
                "send_anonymous_usage_stats": {
                    "oneOf": [
                        {
                            "type": "boolean"
                        },
                        {
                            "type": "null"
                        }
                    ],
                    "description": "Whether dbt is configured to send anonymous usage statistics"
                },
                "adapter_type": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ],
                    "description": "The type name of the adapter"
                }
            },
            "additionalProperties": false,
            "description": "Metadata for the manifest."
        },
        "AnalysisNode": {
            "type": "object",
            "required": [
                "schema",
                "name",
                "resource_type",
                "package_name",
                "path",
                "original_file_path",
                "unique_id",
                "fqn",
                "alias",
                "checksum"
            ],
            "properties": {
                "database": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "schema": {
                    "type": "string"
                },
                "name": {
                    "type": "string"
                },
                "resource_type": {
                    "type": "string",
                    "enum": ["analysis"]
                },
                "package_name": {
                    "type": "string"
                },
                "path": {
                    "type": "string"
                },
                "original_file_path": {
                    "type": "string"
                },
                "unique_id": {
                    "type": "string"
                },
                "fqn": {
                    "type": "array",
                    "items": {
                        "type": "string"
                    }
                },
                "alias": {
                    "type": "string"
                },
                "checksum": {
                    "$ref": "#/definitions/FileHash"
                },
                "config": {
                    "$ref": "#/definitions/NodeConfig",
                    "default": {
                        "enabled": true,
                        "alias": null,
                        "schema": null,
                        "database": null,
                        "tags": [],
                        "meta": {},
                        "group": null,
                        "materialized": "view",
                        "incremental_strategy": null,
                        "persist_docs": {},
                        "quoting": {},
                        "column_types": {},
                        "full_refresh": null,
                        "unique_key": null,
                        "on_schema_change": "ignore",
                        "grants": {},
                        "packages": [],
                        "docs": {
                            "show": true,
                            "node_color": null
                        },
                        "contract": {
                            "enforced": false
                        },
                        "post-hook": [],
                        "pre-hook": []
                    }
                },
                "tags": {
                    "type": "array",
                    "items": {
                        "type": "string"
                    },
                    "default": []
                },
                "description": {
                    "type": "string",
                    "default": ""
                },
                "columns": {
                    "type": "object",
                    "additionalProperties": {
                        "$ref": "#/definitions/ColumnInfo"
                    },
                    "default": {}
                },
                "meta": {
                    "type": "object",
                    "default": {}
                },
                "group": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "docs": {
                    "$ref": "#/definitions/Docs",
                    "default": {
                        "show": true,
                        "node_color": null
                    }
                },
                "patch_path": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "build_path": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "deferred": {
                    "type": "boolean",
                    "default": false
                },
                "unrendered_config": {
                    "type": "object",
                    "default": {}
                },
                "created_at": {
                    "type": "number",
                    "default": 1682075346.49809
                },
                "config_call_dict": {
                    "type": "object",
                    "default": {}
                },
                "relation_name": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "raw_code": {
                    "type": "string",
                    "default": ""
                },
                "language": {
                    "type": "string",
                    "default": "sql"
                },
                "refs": {
                    "type": "array",
                    "items": {
                        "$ref": "#/definitions/RefArgs"
                    },
                    "default": []
                },
                "sources": {
                    "type": "array",
                    "items": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        }
                    },
                    "default": []
                },
                "metrics": {
                    "type": "array",
                    "items": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        }
                    },
                    "default": []
                },
                "depends_on": {
                    "$ref": "#/definitions/DependsOn",
                    "default": {
                        "macros": [],
                        "nodes": []
                    }
                },
                "compiled_path": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "compiled": {
                    "type": "boolean",
                    "default": false
                },
                "compiled_code": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "extra_ctes_injected": {
                    "type": "boolean",
                    "default": false
                },
                "extra_ctes": {
                    "type": "array",
                    "items": {
                        "$ref": "#/definitions/InjectedCTE"
                    },
                    "default": []
                },
                "contract": {
                    "$ref": "#/definitions/Contract",
                    "default": {
                        "enforced": false,
                        "checksum": null
                    }
                }
            },
            "additionalProperties": false,
            "description": "AnalysisNode(database: Optional[str], schema: str, name: str, resource_type: dbt.node_types.NodeType, package_name: str, path: str, original_file_path: str, unique_id: str, fqn: List[str], alias: str, checksum: dbt.contracts.files.FileHash, config: dbt.contracts.graph.model_config.NodeConfig = <factory>, _event_status: Dict[str, Any] = <factory>, tags: List[str] = <factory>, description: str = '', columns: Dict[str, dbt.contracts.graph.nodes.ColumnInfo] = <factory>, meta: Dict[str, Any] = <factory>, group: Optional[str] = None, docs: dbt.contracts.graph.unparsed.Docs = <factory>, patch_path: Optional[str] = None, build_path: Optional[str] = None, deferred: bool = False, unrendered_config: Dict[str, Any] = <factory>, created_at: float = <factory>, config_call_dict: Dict[str, Any] = <factory>, relation_name: Optional[str] = None, raw_code: str = '', language: str = 'sql', refs: List[dbt.contracts.graph.nodes.RefArgs] = <factory>, sources: List[List[str]] = <factory>, metrics: List[List[str]] = <factory>, depends_on: dbt.contracts.graph.nodes.DependsOn = <factory>, compiled_path: Optional[str] = None, compiled: bool = False, compiled_code: Optional[str] = None, extra_ctes_injected: bool = False, extra_ctes: List[dbt.contracts.graph.nodes.InjectedCTE] = <factory>, _pre_injected_sql: Optional[str] = None, contract: dbt.contracts.graph.nodes.Contract = <factory>)"
        },
        "FileHash": {
            "type": "object",
            "required": ["name", "checksum"],
            "properties": {
                "name": {
                    "type": "string"
                },
                "checksum": {
                    "type": "string"
                }
            },
            "additionalProperties": false,
            "description": "FileHash(name: str, checksum: str)"
        },
        "NodeConfig": {
            "type": "object",
            "required": [],
            "properties": {
                "enabled": {
                    "type": "boolean",
                    "default": true
                },
                "alias": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "schema": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "database": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "tags": {
                    "oneOf": [
                        {
                            "type": "array",
                            "items": {
                                "type": "string"
                            }
                        },
                        {
                            "type": "string"
                        }
                    ],
                    "default": []
                },
                "meta": {
                    "type": "object",
                    "default": {}
                },
                "group": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "materialized": {
                    "type": "string",
                    "default": "view"
                },
                "incremental_strategy": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "persist_docs": {
                    "type": "object",
                    "default": {}
                },
                "post-hook": {
                    "type": "array",
                    "items": {
                        "$ref": "#/definitions/Hook"
                    },
                    "default": []
                },
                "pre-hook": {
                    "type": "array",
                    "items": {
                        "$ref": "#/definitions/Hook"
                    },
                    "default": []
                },
                "quoting": {
                    "type": "object",
                    "default": {}
                },
                "column_types": {
                    "type": "object",
                    "default": {}
                },
                "full_refresh": {
                    "oneOf": [
                        {
                            "type": "boolean"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "unique_key": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "array",
                            "items": {
                                "type": "string"
                            }
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "on_schema_change": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ],
                    "default": "ignore"
                },
                "grants": {
                    "type": "object",
                    "default": {}
                },
                "packages": {
                    "type": "array",
                    "items": {
                        "type": "string"
                    },
                    "default": []
                },
                "docs": {
                    "$ref": "#/definitions/Docs",
                    "default": {
                        "show": true,
                        "node_color": null
                    }
                },
                "contract": {
                    "$ref": "#/definitions/ContractConfig",
                    "default": {
                        "enforced": false
                    }
                }
            },
            "additionalProperties": true,
            "description": "NodeConfig(_extra: Dict[str, Any] = <factory>, enabled: bool = True, alias: Optional[str] = None, schema: Optional[str] = None, database: Optional[str] = None, tags: Union[List[str], str] = <factory>, meta: Dict[str, Any] = <factory>, group: Optional[str] = None, materialized: str = 'view', incremental_strategy: Optional[str] = None, persist_docs: Dict[str, Any] = <factory>, post_hook: List[dbt.contracts.graph.model_config.Hook] = <factory>, pre_hook: List[dbt.contracts.graph.model_config.Hook] = <factory>, quoting: Dict[str, Any] = <factory>, column_types: Dict[str, Any] = <factory>, full_refresh: Optional[bool] = None, unique_key: Union[str, List[str], NoneType] = None, on_schema_change: Optional[str] = 'ignore', grants: Dict[str, Any] = <factory>, packages: List[str] = <factory>, docs: dbt.contracts.graph.unparsed.Docs = <factory>, contract: dbt.contracts.graph.model_config.ContractConfig = <factory>)"
        },
        "Hook": {
            "type": "object",
            "required": ["sql"],
            "properties": {
                "sql": {
                    "type": "string"
                },
                "transaction": {
                    "type": "boolean",
                    "default": true
                },
                "index": {
                    "oneOf": [
                        {
                            "type": "integer"
                        },
                        {
                            "type": "null"
                        }
                    ]
                }
            },
            "additionalProperties": false,
            "description": "Hook(sql: str, transaction: bool = True, index: Optional[int] = None)"
        },
        "Docs": {
            "type": "object",
            "required": [],
            "properties": {
                "show": {
                    "type": "boolean",
                    "default": true
                },
                "node_color": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                }
            },
            "additionalProperties": false,
            "description": "Docs(show: bool = True, node_color: Optional[str] = None)"
        },
        "ContractConfig": {
            "type": "object",
            "required": [],
            "properties": {
                "enforced": {
                    "type": "boolean",
                    "default": false
                }
            },
            "additionalProperties": false,
            "description": "ContractConfig(enforced: bool = False)"
        },
        "ColumnInfo": {
            "type": "object",
            "required": ["name"],
            "properties": {
                "name": {
                    "type": "string"
                },
                "description": {
                    "type": "string",
                    "default": ""
                },
                "meta": {
                    "type": "object",
                    "default": {}
                },
                "data_type": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "constraints": {
                    "type": "array",
                    "items": {
                        "$ref": "#/definitions/ColumnLevelConstraint"
                    },
                    "default": []
                },
                "quote": {
                    "oneOf": [
                        {
                            "type": "boolean"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "tags": {
                    "type": "array",
                    "items": {
                        "type": "string"
                    },
                    "default": []
                }
            },
            "additionalProperties": true,
            "description": "Used in all ManifestNodes and SourceDefinition"
        },
        "ColumnLevelConstraint": {
            "type": "object",
            "required": ["type"],
            "properties": {
                "type": {
                    "type": "string",
                    "enum": [
                        "check",
                        "not_null",
                        "unique",
                        "primary_key",
                        "foreign_key",
                        "custom"
                    ]
                },
                "name": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "expression": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "warn_unenforced": {
                    "type": "boolean",
                    "default": true
                },
                "warn_unsupported": {
                    "type": "boolean",
                    "default": true
                }
            },
            "additionalProperties": false,
            "description": "ColumnLevelConstraint(type: dbt.contracts.graph.nodes.ConstraintType, name: Optional[str] = None, expression: Optional[str] = None, warn_unenforced: bool = True, warn_unsupported: bool = True)"
        },
        "RefArgs": {
            "type": "object",
            "required": ["name"],
            "properties": {
                "name": {
                    "type": "string"
                },
                "package": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "version": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "number"
                        },
                        {
                            "type": "null"
                        }
                    ]
                }
            },
            "additionalProperties": false,
            "description": "RefArgs(name: str, package: Optional[str] = None, version: Union[str, float, NoneType] = None)"
        },
        "DependsOn": {
            "type": "object",
            "required": [],
            "properties": {
                "macros": {
                    "type": "array",
                    "items": {
                        "type": "string"
                    },
                    "default": []
                },
                "nodes": {
                    "type": "array",
                    "items": {
                        "type": "string"
                    },
                    "default": []
                }
            },
            "additionalProperties": false,
            "description": "DependsOn(macros: List[str] = <factory>, nodes: List[str] = <factory>)"
        },
        "InjectedCTE": {
            "type": "object",
            "required": ["id", "sql"],
            "properties": {
                "id": {
                    "type": "string"
                },
                "sql": {
                    "type": "string"
                }
            },
            "additionalProperties": false,
            "description": "Used in CompiledNodes as part of ephemeral model processing"
        },
        "Contract": {
            "type": "object",
            "required": [],
            "properties": {
                "enforced": {
                    "type": "boolean",
                    "default": false
                },
                "checksum": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                }
            },
            "additionalProperties": false,
            "description": "Contract(enforced: bool = False, checksum: Optional[str] = None)"
        },
        "SingularTestNode": {
            "type": "object",
            "required": [
                "schema",
                "name",
                "resource_type",
                "package_name",
                "path",
                "original_file_path",
                "unique_id",
                "fqn",
                "alias",
                "checksum"
            ],
            "properties": {
                "database": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "schema": {
                    "type": "string"
                },
                "name": {
                    "type": "string"
                },
                "resource_type": {
                    "type": "string",
                    "enum": ["test"]
                },
                "package_name": {
                    "type": "string"
                },
                "path": {
                    "type": "string"
                },
                "original_file_path": {
                    "type": "string"
                },
                "unique_id": {
                    "type": "string"
                },
                "fqn": {
                    "type": "array",
                    "items": {
                        "type": "string"
                    }
                },
                "alias": {
                    "type": "string"
                },
                "checksum": {
                    "$ref": "#/definitions/FileHash"
                },
                "config": {
                    "$ref": "#/definitions/TestConfig",
                    "default": {
                        "enabled": true,
                        "alias": null,
                        "schema": "dbt_test__audit",
                        "database": null,
                        "tags": [],
                        "meta": {},
                        "group": null,
                        "materialized": "test",
                        "severity": "ERROR",
                        "store_failures": null,
                        "where": null,
                        "limit": null,
                        "fail_calc": "count(*)",
                        "warn_if": "!= 0",
                        "error_if": "!= 0"
                    }
                },
                "tags": {
                    "type": "array",
                    "items": {
                        "type": "string"
                    },
                    "default": []
                },
                "description": {
                    "type": "string",
                    "default": ""
                },
                "columns": {
                    "type": "object",
                    "additionalProperties": {
                        "$ref": "#/definitions/ColumnInfo"
                    },
                    "default": {}
                },
                "meta": {
                    "type": "object",
                    "default": {}
                },
                "group": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "docs": {
                    "$ref": "#/definitions/Docs",
                    "default": {
                        "show": true,
                        "node_color": null
                    }
                },
                "patch_path": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "build_path": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "deferred": {
                    "type": "boolean",
                    "default": false
                },
                "unrendered_config": {
                    "type": "object",
                    "default": {}
                },
                "created_at": {
                    "type": "number",
                    "default": 1682075346.499299
                },
                "config_call_dict": {
                    "type": "object",
                    "default": {}
                },
                "relation_name": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "raw_code": {
                    "type": "string",
                    "default": ""
                },
                "language": {
                    "type": "string",
                    "default": "sql"
                },
                "refs": {
                    "type": "array",
                    "items": {
                        "$ref": "#/definitions/RefArgs"
                    },
                    "default": []
                },
                "sources": {
                    "type": "array",
                    "items": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        }
                    },
                    "default": []
                },
                "metrics": {
                    "type": "array",
                    "items": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        }
                    },
                    "default": []
                },
                "depends_on": {
                    "$ref": "#/definitions/DependsOn",
                    "default": {
                        "macros": [],
                        "nodes": []
                    }
                },
                "compiled_path": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "compiled": {
                    "type": "boolean",
                    "default": false
                },
                "compiled_code": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "extra_ctes_injected": {
                    "type": "boolean",
                    "default": false
                },
                "extra_ctes": {
                    "type": "array",
                    "items": {
                        "$ref": "#/definitions/InjectedCTE"
                    },
                    "default": []
                },
                "contract": {
                    "$ref": "#/definitions/Contract",
                    "default": {
                        "enforced": false,
                        "checksum": null
                    }
                }
            },
            "additionalProperties": false,
            "description": "SingularTestNode(database: Optional[str], schema: str, name: str, resource_type: dbt.node_types.NodeType, package_name: str, path: str, original_file_path: str, unique_id: str, fqn: List[str], alias: str, checksum: dbt.contracts.files.FileHash, config: dbt.contracts.graph.model_config.TestConfig = <factory>, _event_status: Dict[str, Any] = <factory>, tags: List[str] = <factory>, description: str = '', columns: Dict[str, dbt.contracts.graph.nodes.ColumnInfo] = <factory>, meta: Dict[str, Any] = <factory>, group: Optional[str] = None, docs: dbt.contracts.graph.unparsed.Docs = <factory>, patch_path: Optional[str] = None, build_path: Optional[str] = None, deferred: bool = False, unrendered_config: Dict[str, Any] = <factory>, created_at: float = <factory>, config_call_dict: Dict[str, Any] = <factory>, relation_name: Optional[str] = None, raw_code: str = '', language: str = 'sql', refs: List[dbt.contracts.graph.nodes.RefArgs] = <factory>, sources: List[List[str]] = <factory>, metrics: List[List[str]] = <factory>, depends_on: dbt.contracts.graph.nodes.DependsOn = <factory>, compiled_path: Optional[str] = None, compiled: bool = False, compiled_code: Optional[str] = None, extra_ctes_injected: bool = False, extra_ctes: List[dbt.contracts.graph.nodes.InjectedCTE] = <factory>, _pre_injected_sql: Optional[str] = None, contract: dbt.contracts.graph.nodes.Contract = <factory>)"
        },
        "TestConfig": {
            "type": "object",
            "required": [],
            "properties": {
                "enabled": {
                    "type": "boolean",
                    "default": true
                },
                "alias": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "schema": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ],
                    "default": "dbt_test__audit"
                },
                "database": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "tags": {
                    "oneOf": [
                        {
                            "type": "array",
                            "items": {
                                "type": "string"
                            }
                        },
                        {
                            "type": "string"
                        }
                    ],
                    "default": []
                },
                "meta": {
                    "type": "object",
                    "default": {}
                },
                "group": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "materialized": {
                    "type": "string",
                    "default": "test"
                },
                "severity": {
                    "type": "string",
                    "pattern": "^([Ww][Aa][Rr][Nn]|[Ee][Rr][Rr][Oo][Rr])$",
                    "default": "ERROR"
                },
                "store_failures": {
                    "oneOf": [
                        {
                            "type": "boolean"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "where": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "limit": {
                    "oneOf": [
                        {
                            "type": "integer"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "fail_calc": {
                    "type": "string",
                    "default": "count(*)"
                },
                "warn_if": {
                    "type": "string",
                    "default": "!= 0"
                },
                "error_if": {
                    "type": "string",
                    "default": "!= 0"
                }
            },
            "additionalProperties": true,
            "description": "TestConfig(_extra: Dict[str, Any] = <factory>, enabled: bool = True, alias: Optional[str] = None, schema: Optional[str] = 'dbt_test__audit', database: Optional[str] = None, tags: Union[List[str], str] = <factory>, meta: Dict[str, Any] = <factory>, group: Optional[str] = None, materialized: str = 'test', severity: dbt.contracts.graph.model_config.Severity = 'ERROR', store_failures: Optional[bool] = None, where: Optional[str] = None, limit: Optional[int] = None, fail_calc: str = 'count(*)', warn_if: str = '!= 0', error_if: str = '!= 0')"
        },
        "HookNode": {
            "type": "object",
            "required": [
                "schema",
                "name",
                "resource_type",
                "package_name",
                "path",
                "original_file_path",
                "unique_id",
                "fqn",
                "alias",
                "checksum"
            ],
            "properties": {
                "database": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "schema": {
                    "type": "string"
                },
                "name": {
                    "type": "string"
                },
                "resource_type": {
                    "type": "string",
                    "enum": ["operation"]
                },
                "package_name": {
                    "type": "string"
                },
                "path": {
                    "type": "string"
                },
                "original_file_path": {
                    "type": "string"
                },
                "unique_id": {
                    "type": "string"
                },
                "fqn": {
                    "type": "array",
                    "items": {
                        "type": "string"
                    }
                },
                "alias": {
                    "type": "string"
                },
                "checksum": {
                    "$ref": "#/definitions/FileHash"
                },
                "config": {
                    "$ref": "#/definitions/NodeConfig",
                    "default": {
                        "enabled": true,
                        "alias": null,
                        "schema": null,
                        "database": null,
                        "tags": [],
                        "meta": {},
                        "group": null,
                        "materialized": "view",
                        "incremental_strategy": null,
                        "persist_docs": {},
                        "quoting": {},
                        "column_types": {},
                        "full_refresh": null,
                        "unique_key": null,
                        "on_schema_change": "ignore",
                        "grants": {},
                        "packages": [],
                        "docs": {
                            "show": true,
                            "node_color": null
                        },
                        "contract": {
                            "enforced": false
                        },
                        "post-hook": [],
                        "pre-hook": []
                    }
                },
                "tags": {
                    "type": "array",
                    "items": {
                        "type": "string"
                    },
                    "default": []
                },
                "description": {
                    "type": "string",
                    "default": ""
                },
                "columns": {
                    "type": "object",
                    "additionalProperties": {
                        "$ref": "#/definitions/ColumnInfo"
                    },
                    "default": {}
                },
                "meta": {
                    "type": "object",
                    "default": {}
                },
                "group": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "docs": {
                    "$ref": "#/definitions/Docs",
                    "default": {
                        "show": true,
                        "node_color": null
                    }
                },
                "patch_path": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "build_path": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "deferred": {
                    "type": "boolean",
                    "default": false
                },
                "unrendered_config": {
                    "type": "object",
                    "default": {}
                },
                "created_at": {
                    "type": "number",
                    "default": 1682075346.4999008
                },
                "config_call_dict": {
                    "type": "object",
                    "default": {}
                },
                "relation_name": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "raw_code": {
                    "type": "string",
                    "default": ""
                },
                "language": {
                    "type": "string",
                    "default": "sql"
                },
                "refs": {
                    "type": "array",
                    "items": {
                        "$ref": "#/definitions/RefArgs"
                    },
                    "default": []
                },
                "sources": {
                    "type": "array",
                    "items": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        }
                    },
                    "default": []
                },
                "metrics": {
                    "type": "array",
                    "items": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        }
                    },
                    "default": []
                },
                "depends_on": {
                    "$ref": "#/definitions/DependsOn",
                    "default": {
                        "macros": [],
                        "nodes": []
                    }
                },
                "compiled_path": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "compiled": {
                    "type": "boolean",
                    "default": false
                },
                "compiled_code": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "extra_ctes_injected": {
                    "type": "boolean",
                    "default": false
                },
                "extra_ctes": {
                    "type": "array",
                    "items": {
                        "$ref": "#/definitions/InjectedCTE"
                    },
                    "default": []
                },
                "contract": {
                    "$ref": "#/definitions/Contract",
                    "default": {
                        "enforced": false,
                        "checksum": null
                    }
                },
                "index": {
                    "oneOf": [
                        {
                            "type": "integer"
                        },
                        {
                            "type": "null"
                        }
                    ]
                }
            },
            "additionalProperties": false,
            "description": "HookNode(database: Optional[str], schema: str, name: str, resource_type: dbt.node_types.NodeType, package_name: str, path: str, original_file_path: str, unique_id: str, fqn: List[str], alias: str, checksum: dbt.contracts.files.FileHash, config: dbt.contracts.graph.model_config.NodeConfig = <factory>, _event_status: Dict[str, Any] = <factory>, tags: List[str] = <factory>, description: str = '', columns: Dict[str, dbt.contracts.graph.nodes.ColumnInfo] = <factory>, meta: Dict[str, Any] = <factory>, group: Optional[str] = None, docs: dbt.contracts.graph.unparsed.Docs = <factory>, patch_path: Optional[str] = None, build_path: Optional[str] = None, deferred: bool = False, unrendered_config: Dict[str, Any] = <factory>, created_at: float = <factory>, config_call_dict: Dict[str, Any] = <factory>, relation_name: Optional[str] = None, raw_code: str = '', language: str = 'sql', refs: List[dbt.contracts.graph.nodes.RefArgs] = <factory>, sources: List[List[str]] = <factory>, metrics: List[List[str]] = <factory>, depends_on: dbt.contracts.graph.nodes.DependsOn = <factory>, compiled_path: Optional[str] = None, compiled: bool = False, compiled_code: Optional[str] = None, extra_ctes_injected: bool = False, extra_ctes: List[dbt.contracts.graph.nodes.InjectedCTE] = <factory>, _pre_injected_sql: Optional[str] = None, contract: dbt.contracts.graph.nodes.Contract = <factory>, index: Optional[int] = None)"
        },
        "ModelNode": {
            "type": "object",
            "required": [
                "schema",
                "name",
                "resource_type",
                "package_name",
                "path",
                "original_file_path",
                "unique_id",
                "fqn",
                "alias",
                "checksum"
            ],
            "properties": {
                "database": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "schema": {
                    "type": "string"
                },
                "name": {
                    "type": "string"
                },
                "resource_type": {
                    "type": "string",
                    "enum": ["model"]
                },
                "package_name": {
                    "type": "string"
                },
                "path": {
                    "type": "string"
                },
                "original_file_path": {
                    "type": "string"
                },
                "unique_id": {
                    "type": "string"
                },
                "fqn": {
                    "type": "array",
                    "items": {
                        "type": "string"
                    }
                },
                "alias": {
                    "type": "string"
                },
                "checksum": {
                    "$ref": "#/definitions/FileHash"
                },
                "config": {
                    "$ref": "#/definitions/NodeConfig",
                    "default": {
                        "enabled": true,
                        "alias": null,
                        "schema": null,
                        "database": null,
                        "tags": [],
                        "meta": {},
                        "group": null,
                        "materialized": "view",
                        "incremental_strategy": null,
                        "persist_docs": {},
                        "quoting": {},
                        "column_types": {},
                        "full_refresh": null,
                        "unique_key": null,
                        "on_schema_change": "ignore",
                        "grants": {},
                        "packages": [],
                        "docs": {
                            "show": true,
                            "node_color": null
                        },
                        "contract": {
                            "enforced": false
                        },
                        "post-hook": [],
                        "pre-hook": []
                    }
                },
                "tags": {
                    "type": "array",
                    "items": {
                        "type": "string"
                    },
                    "default": []
                },
                "description": {
                    "type": "string",
                    "default": ""
                },
                "columns": {
                    "type": "object",
                    "additionalProperties": {
                        "$ref": "#/definitions/ColumnInfo"
                    },
                    "default": {}
                },
                "meta": {
                    "type": "object",
                    "default": {}
                },
                "group": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "docs": {
                    "$ref": "#/definitions/Docs",
                    "default": {
                        "show": true,
                        "node_color": null
                    }
                },
                "patch_path": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "build_path": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "deferred": {
                    "type": "boolean",
                    "default": false
                },
                "unrendered_config": {
                    "type": "object",
                    "default": {}
                },
                "created_at": {
                    "type": "number",
                    "default": 1682075346.500488
                },
                "config_call_dict": {
                    "type": "object",
                    "default": {}
                },
                "relation_name": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "raw_code": {
                    "type": "string",
                    "default": ""
                },
                "language": {
                    "type": "string",
                    "default": "sql"
                },
                "refs": {
                    "type": "array",
                    "items": {
                        "$ref": "#/definitions/RefArgs"
                    },
                    "default": []
                },
                "sources": {
                    "type": "array",
                    "items": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        }
                    },
                    "default": []
                },
                "metrics": {
                    "type": "array",
                    "items": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        }
                    },
                    "default": []
                },
                "depends_on": {
                    "$ref": "#/definitions/DependsOn",
                    "default": {
                        "macros": [],
                        "nodes": []
                    }
                },
                "compiled_path": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "compiled": {
                    "type": "boolean",
                    "default": false
                },
                "compiled_code": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "extra_ctes_injected": {
                    "type": "boolean",
                    "default": false
                },
                "extra_ctes": {
                    "type": "array",
                    "items": {
                        "$ref": "#/definitions/InjectedCTE"
                    },
                    "default": []
                },
                "contract": {
                    "$ref": "#/definitions/Contract",
                    "default": {
                        "enforced": false,
                        "checksum": null
                    }
                },
                "access": {
                    "type": "string",
                    "enum": ["protected", "private", "public"],
                    "default": "protected"
                },
                "constraints": {
                    "type": "array",
                    "items": {
                        "$ref": "#/definitions/ModelLevelConstraint"
                    },
                    "default": []
                },
                "version": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "number"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "latest_version": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "number"
                        },
                        {
                            "type": "null"
                        }
                    ]
                }
            },
            "additionalProperties": false,
            "description": "ModelNode(database: Optional[str], schema: str, name: str, resource_type: dbt.node_types.NodeType, package_name: str, path: str, original_file_path: str, unique_id: str, fqn: List[str], alias: str, checksum: dbt.contracts.files.FileHash, config: dbt.contracts.graph.model_config.NodeConfig = <factory>, _event_status: Dict[str, Any] = <factory>, tags: List[str] = <factory>, description: str = '', columns: Dict[str, dbt.contracts.graph.nodes.ColumnInfo] = <factory>, meta: Dict[str, Any] = <factory>, group: Optional[str] = None, docs: dbt.contracts.graph.unparsed.Docs = <factory>, patch_path: Optional[str] = None, build_path: Optional[str] = None, deferred: bool = False, unrendered_config: Dict[str, Any] = <factory>, created_at: float = <factory>, config_call_dict: Dict[str, Any] = <factory>, relation_name: Optional[str] = None, raw_code: str = '', language: str = 'sql', refs: List[dbt.contracts.graph.nodes.RefArgs] = <factory>, sources: List[List[str]] = <factory>, metrics: List[List[str]] = <factory>, depends_on: dbt.contracts.graph.nodes.DependsOn = <factory>, compiled_path: Optional[str] = None, compiled: bool = False, compiled_code: Optional[str] = None, extra_ctes_injected: bool = False, extra_ctes: List[dbt.contracts.graph.nodes.InjectedCTE] = <factory>, _pre_injected_sql: Optional[str] = None, contract: dbt.contracts.graph.nodes.Contract = <factory>, access: dbt.node_types.AccessType = <AccessType.Protected: 'protected'>, constraints: List[dbt.contracts.graph.nodes.ModelLevelConstraint] = <factory>, version: Union[str, float, NoneType] = None, latest_version: Union[str, float, NoneType] = None)"
        },
        "ModelLevelConstraint": {
            "type": "object",
            "required": ["type"],
            "properties": {
                "type": {
                    "type": "string",
                    "enum": [
                        "check",
                        "not_null",
                        "unique",
                        "primary_key",
                        "foreign_key",
                        "custom"
                    ]
                },
                "name": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "expression": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "warn_unenforced": {
                    "type": "boolean",
                    "default": true
                },
                "warn_unsupported": {
                    "type": "boolean",
                    "default": true
                },
                "columns": {
                    "type": "array",
                    "items": {
                        "type": "string"
                    },
                    "default": []
                }
            },
            "additionalProperties": false,
            "description": "ModelLevelConstraint(type: dbt.contracts.graph.nodes.ConstraintType, name: Optional[str] = None, expression: Optional[str] = None, warn_unenforced: bool = True, warn_unsupported: bool = True, columns: List[str] = <factory>)"
        },
        "RPCNode": {
            "type": "object",
            "required": [
                "schema",
                "name",
                "resource_type",
                "package_name",
                "path",
                "original_file_path",
                "unique_id",
                "fqn",
                "alias",
                "checksum"
            ],
            "properties": {
                "database": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "schema": {
                    "type": "string"
                },
                "name": {
                    "type": "string"
                },
                "resource_type": {
                    "type": "string",
                    "enum": ["rpc"]
                },
                "package_name": {
                    "type": "string"
                },
                "path": {
                    "type": "string"
                },
                "original_file_path": {
                    "type": "string"
                },
                "unique_id": {
                    "type": "string"
                },
                "fqn": {
                    "type": "array",
                    "items": {
                        "type": "string"
                    }
                },
                "alias": {
                    "type": "string"
                },
                "checksum": {
                    "$ref": "#/definitions/FileHash"
                },
                "config": {
                    "$ref": "#/definitions/NodeConfig",
                    "default": {
                        "enabled": true,
                        "alias": null,
                        "schema": null,
                        "database": null,
                        "tags": [],
                        "meta": {},
                        "group": null,
                        "materialized": "view",
                        "incremental_strategy": null,
                        "persist_docs": {},
                        "quoting": {},
                        "column_types": {},
                        "full_refresh": null,
                        "unique_key": null,
                        "on_schema_change": "ignore",
                        "grants": {},
                        "packages": [],
                        "docs": {
                            "show": true,
                            "node_color": null
                        },
                        "contract": {
                            "enforced": false
                        },
                        "post-hook": [],
                        "pre-hook": []
                    }
                },
                "tags": {
                    "type": "array",
                    "items": {
                        "type": "string"
                    },
                    "default": []
                },
                "description": {
                    "type": "string",
                    "default": ""
                },
                "columns": {
                    "type": "object",
                    "additionalProperties": {
                        "$ref": "#/definitions/ColumnInfo"
                    },
                    "default": {}
                },
                "meta": {
                    "type": "object",
                    "default": {}
                },
                "group": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "docs": {
                    "$ref": "#/definitions/Docs",
                    "default": {
                        "show": true,
                        "node_color": null
                    }
                },
                "patch_path": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "build_path": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "deferred": {
                    "type": "boolean",
                    "default": false
                },
                "unrendered_config": {
                    "type": "object",
                    "default": {}
                },
                "created_at": {
                    "type": "number",
                    "default": 1682075346.50125
                },
                "config_call_dict": {
                    "type": "object",
                    "default": {}
                },
                "relation_name": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "raw_code": {
                    "type": "string",
                    "default": ""
                },
                "language": {
                    "type": "string",
                    "default": "sql"
                },
                "refs": {
                    "type": "array",
                    "items": {
                        "$ref": "#/definitions/RefArgs"
                    },
                    "default": []
                },
                "sources": {
                    "type": "array",
                    "items": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        }
                    },
                    "default": []
                },
                "metrics": {
                    "type": "array",
                    "items": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        }
                    },
                    "default": []
                },
                "depends_on": {
                    "$ref": "#/definitions/DependsOn",
                    "default": {
                        "macros": [],
                        "nodes": []
                    }
                },
                "compiled_path": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "compiled": {
                    "type": "boolean",
                    "default": false
                },
                "compiled_code": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "extra_ctes_injected": {
                    "type": "boolean",
                    "default": false
                },
                "extra_ctes": {
                    "type": "array",
                    "items": {
                        "$ref": "#/definitions/InjectedCTE"
                    },
                    "default": []
                },
                "contract": {
                    "$ref": "#/definitions/Contract",
                    "default": {
                        "enforced": false,
                        "checksum": null
                    }
                }
            },
            "additionalProperties": false,
            "description": "RPCNode(database: Optional[str], schema: str, name: str, resource_type: dbt.node_types.NodeType, package_name: str, path: str, original_file_path: str, unique_id: str, fqn: List[str], alias: str, checksum: dbt.contracts.files.FileHash, config: dbt.contracts.graph.model_config.NodeConfig = <factory>, _event_status: Dict[str, Any] = <factory>, tags: List[str] = <factory>, description: str = '', columns: Dict[str, dbt.contracts.graph.nodes.ColumnInfo] = <factory>, meta: Dict[str, Any] = <factory>, group: Optional[str] = None, docs: dbt.contracts.graph.unparsed.Docs = <factory>, patch_path: Optional[str] = None, build_path: Optional[str] = None, deferred: bool = False, unrendered_config: Dict[str, Any] = <factory>, created_at: float = <factory>, config_call_dict: Dict[str, Any] = <factory>, relation_name: Optional[str] = None, raw_code: str = '', language: str = 'sql', refs: List[dbt.contracts.graph.nodes.RefArgs] = <factory>, sources: List[List[str]] = <factory>, metrics: List[List[str]] = <factory>, depends_on: dbt.contracts.graph.nodes.DependsOn = <factory>, compiled_path: Optional[str] = None, compiled: bool = False, compiled_code: Optional[str] = None, extra_ctes_injected: bool = False, extra_ctes: List[dbt.contracts.graph.nodes.InjectedCTE] = <factory>, _pre_injected_sql: Optional[str] = None, contract: dbt.contracts.graph.nodes.Contract = <factory>)"
        },
        "SqlNode": {
            "type": "object",
            "required": [
                "schema",
                "name",
                "resource_type",
                "package_name",
                "path",
                "original_file_path",
                "unique_id",
                "fqn",
                "alias",
                "checksum"
            ],
            "properties": {
                "database": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "schema": {
                    "type": "string"
                },
                "name": {
                    "type": "string"
                },
                "resource_type": {
                    "type": "string",
                    "enum": ["sql operation"]
                },
                "package_name": {
                    "type": "string"
                },
                "path": {
                    "type": "string"
                },
                "original_file_path": {
                    "type": "string"
                },
                "unique_id": {
                    "type": "string"
                },
                "fqn": {
                    "type": "array",
                    "items": {
                        "type": "string"
                    }
                },
                "alias": {
                    "type": "string"
                },
                "checksum": {
                    "$ref": "#/definitions/FileHash"
                },
                "config": {
                    "$ref": "#/definitions/NodeConfig",
                    "default": {
                        "enabled": true,
                        "alias": null,
                        "schema": null,
                        "database": null,
                        "tags": [],
                        "meta": {},
                        "group": null,
                        "materialized": "view",
                        "incremental_strategy": null,
                        "persist_docs": {},
                        "quoting": {},
                        "column_types": {},
                        "full_refresh": null,
                        "unique_key": null,
                        "on_schema_change": "ignore",
                        "grants": {},
                        "packages": [],
                        "docs": {
                            "show": true,
                            "node_color": null
                        },
                        "contract": {
                            "enforced": false
                        },
                        "post-hook": [],
                        "pre-hook": []
                    }
                },
                "tags": {
                    "type": "array",
                    "items": {
                        "type": "string"
                    },
                    "default": []
                },
                "description": {
                    "type": "string",
                    "default": ""
                },
                "columns": {
                    "type": "object",
                    "additionalProperties": {
                        "$ref": "#/definitions/ColumnInfo"
                    },
                    "default": {}
                },
                "meta": {
                    "type": "object",
                    "default": {}
                },
                "group": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "docs": {
                    "$ref": "#/definitions/Docs",
                    "default": {
                        "show": true,
                        "node_color": null
                    }
                },
                "patch_path": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "build_path": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "deferred": {
                    "type": "boolean",
                    "default": false
                },
                "unrendered_config": {
                    "type": "object",
                    "default": {}
                },
                "created_at": {
                    "type": "number",
                    "default": 1682075346.501826
                },
                "config_call_dict": {
                    "type": "object",
                    "default": {}
                },
                "relation_name": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "raw_code": {
                    "type": "string",
                    "default": ""
                },
                "language": {
                    "type": "string",
                    "default": "sql"
                },
                "refs": {
                    "type": "array",
                    "items": {
                        "$ref": "#/definitions/RefArgs"
                    },
                    "default": []
                },
                "sources": {
                    "type": "array",
                    "items": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        }
                    },
                    "default": []
                },
                "metrics": {
                    "type": "array",
                    "items": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        }
                    },
                    "default": []
                },
                "depends_on": {
                    "$ref": "#/definitions/DependsOn",
                    "default": {
                        "macros": [],
                        "nodes": []
                    }
                },
                "compiled_path": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "compiled": {
                    "type": "boolean",
                    "default": false
                },
                "compiled_code": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "extra_ctes_injected": {
                    "type": "boolean",
                    "default": false
                },
                "extra_ctes": {
                    "type": "array",
                    "items": {
                        "$ref": "#/definitions/InjectedCTE"
                    },
                    "default": []
                },
                "contract": {
                    "$ref": "#/definitions/Contract",
                    "default": {
                        "enforced": false,
                        "checksum": null
                    }
                }
            },
            "additionalProperties": false,
            "description": "SqlNode(database: Optional[str], schema: str, name: str, resource_type: dbt.node_types.NodeType, package_name: str, path: str, original_file_path: str, unique_id: str, fqn: List[str], alias: str, checksum: dbt.contracts.files.FileHash, config: dbt.contracts.graph.model_config.NodeConfig = <factory>, _event_status: Dict[str, Any] = <factory>, tags: List[str] = <factory>, description: str = '', columns: Dict[str, dbt.contracts.graph.nodes.ColumnInfo] = <factory>, meta: Dict[str, Any] = <factory>, group: Optional[str] = None, docs: dbt.contracts.graph.unparsed.Docs = <factory>, patch_path: Optional[str] = None, build_path: Optional[str] = None, deferred: bool = False, unrendered_config: Dict[str, Any] = <factory>, created_at: float = <factory>, config_call_dict: Dict[str, Any] = <factory>, relation_name: Optional[str] = None, raw_code: str = '', language: str = 'sql', refs: List[dbt.contracts.graph.nodes.RefArgs] = <factory>, sources: List[List[str]] = <factory>, metrics: List[List[str]] = <factory>, depends_on: dbt.contracts.graph.nodes.DependsOn = <factory>, compiled_path: Optional[str] = None, compiled: bool = False, compiled_code: Optional[str] = None, extra_ctes_injected: bool = False, extra_ctes: List[dbt.contracts.graph.nodes.InjectedCTE] = <factory>, _pre_injected_sql: Optional[str] = None, contract: dbt.contracts.graph.nodes.Contract = <factory>)"
        },
        "GenericTestNode": {
            "type": "object",
            "required": [
                "test_metadata",
                "schema",
                "name",
                "resource_type",
                "package_name",
                "path",
                "original_file_path",
                "unique_id",
                "fqn",
                "alias",
                "checksum"
            ],
            "properties": {
                "test_metadata": {
                    "$ref": "#/definitions/TestMetadata"
                },
                "database": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "schema": {
                    "type": "string"
                },
                "name": {
                    "type": "string"
                },
                "resource_type": {
                    "type": "string",
                    "enum": ["test"]
                },
                "package_name": {
                    "type": "string"
                },
                "path": {
                    "type": "string"
                },
                "original_file_path": {
                    "type": "string"
                },
                "unique_id": {
                    "type": "string"
                },
                "fqn": {
                    "type": "array",
                    "items": {
                        "type": "string"
                    }
                },
                "alias": {
                    "type": "string"
                },
                "checksum": {
                    "$ref": "#/definitions/FileHash"
                },
                "config": {
                    "$ref": "#/definitions/TestConfig",
                    "default": {
                        "enabled": true,
                        "alias": null,
                        "schema": "dbt_test__audit",
                        "database": null,
                        "tags": [],
                        "meta": {},
                        "group": null,
                        "materialized": "test",
                        "severity": "ERROR",
                        "store_failures": null,
                        "where": null,
                        "limit": null,
                        "fail_calc": "count(*)",
                        "warn_if": "!= 0",
                        "error_if": "!= 0"
                    }
                },
                "tags": {
                    "type": "array",
                    "items": {
                        "type": "string"
                    },
                    "default": []
                },
                "description": {
                    "type": "string",
                    "default": ""
                },
                "columns": {
                    "type": "object",
                    "additionalProperties": {
                        "$ref": "#/definitions/ColumnInfo"
                    },
                    "default": {}
                },
                "meta": {
                    "type": "object",
                    "default": {}
                },
                "group": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "docs": {
                    "$ref": "#/definitions/Docs",
                    "default": {
                        "show": true,
                        "node_color": null
                    }
                },
                "patch_path": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "build_path": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "deferred": {
                    "type": "boolean",
                    "default": false
                },
                "unrendered_config": {
                    "type": "object",
                    "default": {}
                },
                "created_at": {
                    "type": "number",
                    "default": 1682075346.502492
                },
                "config_call_dict": {
                    "type": "object",
                    "default": {}
                },
                "relation_name": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "raw_code": {
                    "type": "string",
                    "default": ""
                },
                "language": {
                    "type": "string",
                    "default": "sql"
                },
                "refs": {
                    "type": "array",
                    "items": {
                        "$ref": "#/definitions/RefArgs"
                    },
                    "default": []
                },
                "sources": {
                    "type": "array",
                    "items": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        }
                    },
                    "default": []
                },
                "metrics": {
                    "type": "array",
                    "items": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        }
                    },
                    "default": []
                },
                "depends_on": {
                    "$ref": "#/definitions/DependsOn",
                    "default": {
                        "macros": [],
                        "nodes": []
                    }
                },
                "compiled_path": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "compiled": {
                    "type": "boolean",
                    "default": false
                },
                "compiled_code": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "extra_ctes_injected": {
                    "type": "boolean",
                    "default": false
                },
                "extra_ctes": {
                    "type": "array",
                    "items": {
                        "$ref": "#/definitions/InjectedCTE"
                    },
                    "default": []
                },
                "contract": {
                    "$ref": "#/definitions/Contract",
                    "default": {
                        "enforced": false,
                        "checksum": null
                    }
                },
                "column_name": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "file_key_name": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "attached_node": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                }
            },
            "additionalProperties": false,
            "description": "GenericTestNode(test_metadata: dbt.contracts.graph.nodes.TestMetadata, database: Optional[str], schema: str, name: str, resource_type: dbt.node_types.NodeType, package_name: str, path: str, original_file_path: str, unique_id: str, fqn: List[str], alias: str, checksum: dbt.contracts.files.FileHash, config: dbt.contracts.graph.model_config.TestConfig = <factory>, _event_status: Dict[str, Any] = <factory>, tags: List[str] = <factory>, description: str = '', columns: Dict[str, dbt.contracts.graph.nodes.ColumnInfo] = <factory>, meta: Dict[str, Any] = <factory>, group: Optional[str] = None, docs: dbt.contracts.graph.unparsed.Docs = <factory>, patch_path: Optional[str] = None, build_path: Optional[str] = None, deferred: bool = False, unrendered_config: Dict[str, Any] = <factory>, created_at: float = <factory>, config_call_dict: Dict[str, Any] = <factory>, relation_name: Optional[str] = None, raw_code: str = '', language: str = 'sql', refs: List[dbt.contracts.graph.nodes.RefArgs] = <factory>, sources: List[List[str]] = <factory>, metrics: List[List[str]] = <factory>, depends_on: dbt.contracts.graph.nodes.DependsOn = <factory>, compiled_path: Optional[str] = None, compiled: bool = False, compiled_code: Optional[str] = None, extra_ctes_injected: bool = False, extra_ctes: List[dbt.contracts.graph.nodes.InjectedCTE] = <factory>, _pre_injected_sql: Optional[str] = None, contract: dbt.contracts.graph.nodes.Contract = <factory>, column_name: Optional[str] = None, file_key_name: Optional[str] = None, attached_node: Optional[str] = None)"
        },
        "TestMetadata": {
            "type": "object",
            "required": ["name"],
            "properties": {
                "name": {
                    "type": "string"
                },
                "kwargs": {
                    "type": "object",
                    "default": {}
                },
                "namespace": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                }
            },
            "additionalProperties": false,
            "description": "TestMetadata(name: str, kwargs: Dict[str, Any] = <factory>, namespace: Optional[str] = None)"
        },
        "SnapshotNode": {
            "type": "object",
            "required": [
                "schema",
                "name",
                "resource_type",
                "package_name",
                "path",
                "original_file_path",
                "unique_id",
                "fqn",
                "alias",
                "checksum",
                "config"
            ],
            "properties": {
                "database": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "schema": {
                    "type": "string"
                },
                "name": {
                    "type": "string"
                },
                "resource_type": {
                    "type": "string",
                    "enum": ["snapshot"]
                },
                "package_name": {
                    "type": "string"
                },
                "path": {
                    "type": "string"
                },
                "original_file_path": {
                    "type": "string"
                },
                "unique_id": {
                    "type": "string"
                },
                "fqn": {
                    "type": "array",
                    "items": {
                        "type": "string"
                    }
                },
                "alias": {
                    "type": "string"
                },
                "checksum": {
                    "$ref": "#/definitions/FileHash"
                },
                "config": {
                    "$ref": "#/definitions/SnapshotConfig"
                },
                "tags": {
                    "type": "array",
                    "items": {
                        "type": "string"
                    },
                    "default": []
                },
                "description": {
                    "type": "string",
                    "default": ""
                },
                "columns": {
                    "type": "object",
                    "additionalProperties": {
                        "$ref": "#/definitions/ColumnInfo"
                    },
                    "default": {}
                },
                "meta": {
                    "type": "object",
                    "default": {}
                },
                "group": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "docs": {
                    "$ref": "#/definitions/Docs",
                    "default": {
                        "show": true,
                        "node_color": null
                    }
                },
                "patch_path": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "build_path": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "deferred": {
                    "type": "boolean",
                    "default": false
                },
                "unrendered_config": {
                    "type": "object",
                    "default": {}
                },
                "created_at": {
                    "type": "number",
                    "default": 1682075346.503581
                },
                "config_call_dict": {
                    "type": "object",
                    "default": {}
                },
                "relation_name": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "raw_code": {
                    "type": "string",
                    "default": ""
                },
                "language": {
                    "type": "string",
                    "default": "sql"
                },
                "refs": {
                    "type": "array",
                    "items": {
                        "$ref": "#/definitions/RefArgs"
                    },
                    "default": []
                },
                "sources": {
                    "type": "array",
                    "items": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        }
                    },
                    "default": []
                },
                "metrics": {
                    "type": "array",
                    "items": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        }
                    },
                    "default": []
                },
                "depends_on": {
                    "$ref": "#/definitions/DependsOn",
                    "default": {
                        "macros": [],
                        "nodes": []
                    }
                },
                "compiled_path": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "compiled": {
                    "type": "boolean",
                    "default": false
                },
                "compiled_code": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "extra_ctes_injected": {
                    "type": "boolean",
                    "default": false
                },
                "extra_ctes": {
                    "type": "array",
                    "items": {
                        "$ref": "#/definitions/InjectedCTE"
                    },
                    "default": []
                },
                "contract": {
                    "$ref": "#/definitions/Contract",
                    "default": {
                        "enforced": false,
                        "checksum": null
                    }
                }
            },
            "additionalProperties": false,
            "description": "SnapshotNode(database: Optional[str], schema: str, name: str, resource_type: dbt.node_types.NodeType, package_name: str, path: str, original_file_path: str, unique_id: str, fqn: List[str], alias: str, checksum: dbt.contracts.files.FileHash, config: dbt.contracts.graph.model_config.SnapshotConfig, _event_status: Dict[str, Any] = <factory>, tags: List[str] = <factory>, description: str = '', columns: Dict[str, dbt.contracts.graph.nodes.ColumnInfo] = <factory>, meta: Dict[str, Any] = <factory>, group: Optional[str] = None, docs: dbt.contracts.graph.unparsed.Docs = <factory>, patch_path: Optional[str] = None, build_path: Optional[str] = None, deferred: bool = False, unrendered_config: Dict[str, Any] = <factory>, created_at: float = <factory>, config_call_dict: Dict[str, Any] = <factory>, relation_name: Optional[str] = None, raw_code: str = '', language: str = 'sql', refs: List[dbt.contracts.graph.nodes.RefArgs] = <factory>, sources: List[List[str]] = <factory>, metrics: List[List[str]] = <factory>, depends_on: dbt.contracts.graph.nodes.DependsOn = <factory>, compiled_path: Optional[str] = None, compiled: bool = False, compiled_code: Optional[str] = None, extra_ctes_injected: bool = False, extra_ctes: List[dbt.contracts.graph.nodes.InjectedCTE] = <factory>, _pre_injected_sql: Optional[str] = None, contract: dbt.contracts.graph.nodes.Contract = <factory>)"
        },
        "SnapshotConfig": {
            "type": "object",
            "required": [],
            "properties": {
                "enabled": {
                    "type": "boolean",
                    "default": true
                },
                "alias": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "schema": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "database": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "tags": {
                    "oneOf": [
                        {
                            "type": "array",
                            "items": {
                                "type": "string"
                            }
                        },
                        {
                            "type": "string"
                        }
                    ],
                    "default": []
                },
                "meta": {
                    "type": "object",
                    "default": {}
                },
                "group": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "materialized": {
                    "type": "string",
                    "default": "snapshot"
                },
                "incremental_strategy": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "persist_docs": {
                    "type": "object",
                    "default": {}
                },
                "post-hook": {
                    "type": "array",
                    "items": {
                        "$ref": "#/definitions/Hook"
                    },
                    "default": []
                },
                "pre-hook": {
                    "type": "array",
                    "items": {
                        "$ref": "#/definitions/Hook"
                    },
                    "default": []
                },
                "quoting": {
                    "type": "object",
                    "default": {}
                },
                "column_types": {
                    "type": "object",
                    "default": {}
                },
                "full_refresh": {
                    "oneOf": [
                        {
                            "type": "boolean"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "unique_key": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "on_schema_change": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ],
                    "default": "ignore"
                },
                "grants": {
                    "type": "object",
                    "default": {}
                },
                "packages": {
                    "type": "array",
                    "items": {
                        "type": "string"
                    },
                    "default": []
                },
                "docs": {
                    "$ref": "#/definitions/Docs",
                    "default": {
                        "show": true,
                        "node_color": null
                    }
                },
                "contract": {
                    "$ref": "#/definitions/ContractConfig",
                    "default": {
                        "enforced": false
                    }
                },
                "strategy": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "target_schema": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "target_database": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "updated_at": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "check_cols": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "array",
                            "items": {
                                "type": "string"
                            }
                        },
                        {
                            "type": "null"
                        }
                    ]
                }
            },
            "additionalProperties": true,
            "description": "SnapshotConfig(_extra: Dict[str, Any] = <factory>, enabled: bool = True, alias: Optional[str] = None, schema: Optional[str] = None, database: Optional[str] = None, tags: Union[List[str], str] = <factory>, meta: Dict[str, Any] = <factory>, group: Optional[str] = None, materialized: str = 'snapshot', incremental_strategy: Optional[str] = None, persist_docs: Dict[str, Any] = <factory>, post_hook: List[dbt.contracts.graph.model_config.Hook] = <factory>, pre_hook: List[dbt.contracts.graph.model_config.Hook] = <factory>, quoting: Dict[str, Any] = <factory>, column_types: Dict[str, Any] = <factory>, full_refresh: Optional[bool] = None, unique_key: Optional[str] = None, on_schema_change: Optional[str] = 'ignore', grants: Dict[str, Any] = <factory>, packages: List[str] = <factory>, docs: dbt.contracts.graph.unparsed.Docs = <factory>, contract: dbt.contracts.graph.model_config.ContractConfig = <factory>, strategy: Optional[str] = None, target_schema: Optional[str] = None, target_database: Optional[str] = None, updated_at: Optional[str] = None, check_cols: Union[str, List[str], NoneType] = None)"
        },
        "SeedNode": {
            "type": "object",
            "required": [
                "schema",
                "name",
                "resource_type",
                "package_name",
                "path",
                "original_file_path",
                "unique_id",
                "fqn",
                "alias",
                "checksum"
            ],
            "properties": {
                "database": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "schema": {
                    "type": "string"
                },
                "name": {
                    "type": "string"
                },
                "resource_type": {
                    "type": "string",
                    "enum": ["seed"]
                },
                "package_name": {
                    "type": "string"
                },
                "path": {
                    "type": "string"
                },
                "original_file_path": {
                    "type": "string"
                },
                "unique_id": {
                    "type": "string"
                },
                "fqn": {
                    "type": "array",
                    "items": {
                        "type": "string"
                    }
                },
                "alias": {
                    "type": "string"
                },
                "checksum": {
                    "$ref": "#/definitions/FileHash"
                },
                "config": {
                    "$ref": "#/definitions/SeedConfig",
                    "default": {
                        "enabled": true,
                        "alias": null,
                        "schema": null,
                        "database": null,
                        "tags": [],
                        "meta": {},
                        "group": null,
                        "materialized": "seed",
                        "incremental_strategy": null,
                        "persist_docs": {},
                        "quoting": {},
                        "column_types": {},
                        "full_refresh": null,
                        "unique_key": null,
                        "on_schema_change": "ignore",
                        "grants": {},
                        "packages": [],
                        "docs": {
                            "show": true,
                            "node_color": null
                        },
                        "contract": {
                            "enforced": false
                        },
                        "quote_columns": null,
                        "post-hook": [],
                        "pre-hook": []
                    }
                },
                "tags": {
                    "type": "array",
                    "items": {
                        "type": "string"
                    },
                    "default": []
                },
                "description": {
                    "type": "string",
                    "default": ""
                },
                "columns": {
                    "type": "object",
                    "additionalProperties": {
                        "$ref": "#/definitions/ColumnInfo"
                    },
                    "default": {}
                },
                "meta": {
                    "type": "object",
                    "default": {}
                },
                "group": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "docs": {
                    "$ref": "#/definitions/Docs",
                    "default": {
                        "show": true,
                        "node_color": null
                    }
                },
                "patch_path": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "build_path": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "deferred": {
                    "type": "boolean",
                    "default": false
                },
                "unrendered_config": {
                    "type": "object",
                    "default": {}
                },
                "created_at": {
                    "type": "number",
                    "default": 1682075346.504591
                },
                "config_call_dict": {
                    "type": "object",
                    "default": {}
                },
                "relation_name": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "raw_code": {
                    "type": "string",
                    "default": ""
                },
                "root_path": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "depends_on": {
                    "$ref": "#/definitions/MacroDependsOn",
                    "default": {
                        "macros": []
                    }
                }
            },
            "additionalProperties": false,
            "description": "SeedNode(database: Optional[str], schema: str, name: str, resource_type: dbt.node_types.NodeType, package_name: str, path: str, original_file_path: str, unique_id: str, fqn: List[str], alias: str, checksum: dbt.contracts.files.FileHash, config: dbt.contracts.graph.model_config.SeedConfig = <factory>, _event_status: Dict[str, Any] = <factory>, tags: List[str] = <factory>, description: str = '', columns: Dict[str, dbt.contracts.graph.nodes.ColumnInfo] = <factory>, meta: Dict[str, Any] = <factory>, group: Optional[str] = None, docs: dbt.contracts.graph.unparsed.Docs = <factory>, patch_path: Optional[str] = None, build_path: Optional[str] = None, deferred: bool = False, unrendered_config: Dict[str, Any] = <factory>, created_at: float = <factory>, config_call_dict: Dict[str, Any] = <factory>, relation_name: Optional[str] = None, raw_code: str = '', root_path: Optional[str] = None, depends_on: dbt.contracts.graph.nodes.MacroDependsOn = <factory>)"
        },
        "SeedConfig": {
            "type": "object",
            "required": [],
            "properties": {
                "enabled": {
                    "type": "boolean",
                    "default": true
                },
                "alias": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "schema": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "database": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "tags": {
                    "oneOf": [
                        {
                            "type": "array",
                            "items": {
                                "type": "string"
                            }
                        },
                        {
                            "type": "string"
                        }
                    ],
                    "default": []
                },
                "meta": {
                    "type": "object",
                    "default": {}
                },
                "group": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "materialized": {
                    "type": "string",
                    "default": "seed"
                },
                "incremental_strategy": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "persist_docs": {
                    "type": "object",
                    "default": {}
                },
                "post-hook": {
                    "type": "array",
                    "items": {
                        "$ref": "#/definitions/Hook"
                    },
                    "default": []
                },
                "pre-hook": {
                    "type": "array",
                    "items": {
                        "$ref": "#/definitions/Hook"
                    },
                    "default": []
                },
                "quoting": {
                    "type": "object",
                    "default": {}
                },
                "column_types": {
                    "type": "object",
                    "default": {}
                },
                "full_refresh": {
                    "oneOf": [
                        {
                            "type": "boolean"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "unique_key": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "array",
                            "items": {
                                "type": "string"
                            }
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "on_schema_change": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ],
                    "default": "ignore"
                },
                "grants": {
                    "type": "object",
                    "default": {}
                },
                "packages": {
                    "type": "array",
                    "items": {
                        "type": "string"
                    },
                    "default": []
                },
                "docs": {
                    "$ref": "#/definitions/Docs",
                    "default": {
                        "show": true,
                        "node_color": null
                    }
                },
                "contract": {
                    "$ref": "#/definitions/ContractConfig",
                    "default": {
                        "enforced": false
                    }
                },
                "quote_columns": {
                    "oneOf": [
                        {
                            "type": "boolean"
                        },
                        {
                            "type": "null"
                        }
                    ]
                }
            },
            "additionalProperties": true,
            "description": "SeedConfig(_extra: Dict[str, Any] = <factory>, enabled: bool = True, alias: Optional[str] = None, schema: Optional[str] = None, database: Optional[str] = None, tags: Union[List[str], str] = <factory>, meta: Dict[str, Any] = <factory>, group: Optional[str] = None, materialized: str = 'seed', incremental_strategy: Optional[str] = None, persist_docs: Dict[str, Any] = <factory>, post_hook: List[dbt.contracts.graph.model_config.Hook] = <factory>, pre_hook: List[dbt.contracts.graph.model_config.Hook] = <factory>, quoting: Dict[str, Any] = <factory>, column_types: Dict[str, Any] = <factory>, full_refresh: Optional[bool] = None, unique_key: Union[str, List[str], NoneType] = None, on_schema_change: Optional[str] = 'ignore', grants: Dict[str, Any] = <factory>, packages: List[str] = <factory>, docs: dbt.contracts.graph.unparsed.Docs = <factory>, contract: dbt.contracts.graph.model_config.ContractConfig = <factory>, quote_columns: Optional[bool] = None)"
        },
        "MacroDependsOn": {
            "type": "object",
            "required": [],
            "properties": {
                "macros": {
                    "type": "array",
                    "items": {
                        "type": "string"
                    },
                    "default": []
                }
            },
            "additionalProperties": false,
            "description": "Used only in the Macro class"
        },
        "SourceDefinition": {
            "type": "object",
            "required": [
                "schema",
                "name",
                "resource_type",
                "package_name",
                "path",
                "original_file_path",
                "unique_id",
                "fqn",
                "source_name",
                "source_description",
                "loader",
                "identifier"
            ],
            "properties": {
                "database": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "schema": {
                    "type": "string"
                },
                "name": {
                    "type": "string"
                },
                "resource_type": {
                    "type": "string",
                    "enum": ["source"]
                },
                "package_name": {
                    "type": "string"
                },
                "path": {
                    "type": "string"
                },
                "original_file_path": {
                    "type": "string"
                },
                "unique_id": {
                    "type": "string"
                },
                "fqn": {
                    "type": "array",
                    "items": {
                        "type": "string"
                    }
                },
                "source_name": {
                    "type": "string"
                },
                "source_description": {
                    "type": "string"
                },
                "loader": {
                    "type": "string"
                },
                "identifier": {
                    "type": "string"
                },
                "quoting": {
                    "$ref": "#/definitions/Quoting",
                    "default": {
                        "database": null,
                        "schema": null,
                        "identifier": null,
                        "column": null
                    }
                },
                "loaded_at_field": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "freshness": {
                    "oneOf": [
                        {
                            "$ref": "#/definitions/FreshnessThreshold"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "external": {
                    "oneOf": [
                        {
                            "$ref": "#/definitions/ExternalTable"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "description": {
                    "type": "string",
                    "default": ""
                },
                "columns": {
                    "type": "object",
                    "additionalProperties": {
                        "$ref": "#/definitions/ColumnInfo"
                    },
                    "default": {}
                },
                "meta": {
                    "type": "object",
                    "default": {}
                },
                "source_meta": {
                    "type": "object",
                    "default": {}
                },
                "tags": {
                    "type": "array",
                    "items": {
                        "type": "string"
                    },
                    "default": []
                },
                "config": {
                    "$ref": "#/definitions/SourceConfig",
                    "default": {
                        "enabled": true
                    }
                },
                "patch_path": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "unrendered_config": {
                    "type": "object",
                    "default": {}
                },
                "relation_name": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "created_at": {
                    "type": "number",
                    "default": 1682075346.505582
                }
            },
            "additionalProperties": false,
            "description": "SourceDefinition(database: Optional[str], schema: str, name: str, resource_type: dbt.node_types.NodeType, package_name: str, path: str, original_file_path: str, unique_id: str, fqn: List[str], source_name: str, source_description: str, loader: str, identifier: str, _event_status: Dict[str, Any] = <factory>, quoting: dbt.contracts.graph.unparsed.Quoting = <factory>, loaded_at_field: Optional[str] = None, freshness: Optional[dbt.contracts.graph.unparsed.FreshnessThreshold] = None, external: Optional[dbt.contracts.graph.unparsed.ExternalTable] = None, description: str = '', columns: Dict[str, dbt.contracts.graph.nodes.ColumnInfo] = <factory>, meta: Dict[str, Any] = <factory>, source_meta: Dict[str, Any] = <factory>, tags: List[str] = <factory>, config: dbt.contracts.graph.model_config.SourceConfig = <factory>, patch_path: Optional[str] = None, unrendered_config: Dict[str, Any] = <factory>, relation_name: Optional[str] = None, created_at: float = <factory>)"
        },
        "Quoting": {
            "type": "object",
            "required": [],
            "properties": {
                "database": {
                    "oneOf": [
                        {
                            "type": "boolean"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "schema": {
                    "oneOf": [
                        {
                            "type": "boolean"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "identifier": {
                    "oneOf": [
                        {
                            "type": "boolean"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "column": {
                    "oneOf": [
                        {
                            "type": "boolean"
                        },
                        {
                            "type": "null"
                        }
                    ]
                }
            },
            "additionalProperties": false,
            "description": "Quoting(database: Optional[bool] = None, schema: Optional[bool] = None, identifier: Optional[bool] = None, column: Optional[bool] = None)"
        },
        "FreshnessThreshold": {
            "type": "object",
            "required": [],
            "properties": {
                "warn_after": {
                    "oneOf": [
                        {
                            "$ref": "#/definitions/Time"
                        },
                        {
                            "type": "null"
                        }
                    ],
                    "default": {
                        "count": null,
                        "period": null
                    }
                },
                "error_after": {
                    "oneOf": [
                        {
                            "$ref": "#/definitions/Time"
                        },
                        {
                            "type": "null"
                        }
                    ],
                    "default": {
                        "count": null,
                        "period": null
                    }
                },
                "filter": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                }
            },
            "additionalProperties": false,
            "description": "FreshnessThreshold(warn_after: Optional[dbt.contracts.graph.unparsed.Time] = <factory>, error_after: Optional[dbt.contracts.graph.unparsed.Time] = <factory>, filter: Optional[str] = None)"
        },
        "FreshnessMetadata": {
            "type": "object",
            "required": [],
            "properties": {
                "dbt_schema_version": {
                    "type": "string",
                    "default": "https://schemas.getdbt.com/dbt/sources/v3.json"
                },
                "dbt_version": {
                    "type": "string",
                    "default": "1.6.0a1"
                },
                "generated_at": {
                    "type": "string",
                    "format": "date-time",
                    "default": "2023-04-21T11:09:06.494387Z"
                },
                "invocation_id": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ],
                    "default": "c4b245be-8edb-4ad7-ba54-9337ce594f5d"
                },
                "env": {
                    "type": "object",
                    "additionalProperties": {
                        "type": "string"
                    },
                    "default": {}
                }
            },
            "additionalProperties": false,
            "description": "FreshnessMetadata(dbt_schema_version: str = <factory>, dbt_version: str = '1.6.0a1', generated_at: datetime.datetime = <factory>, invocation_id: Optional[str] = <factory>, env: Dict[str, str] = <factory>)"
        },
        "SourceFreshnessRuntimeError": {
            "type": "object",
            "required": ["unique_id", "status"],
            "properties": {
                "unique_id": {
                    "type": "string"
                },
                "error": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "integer"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "status": {
                    "type": "string",
                    "enum": ["runtime error"]
                }
            },
            "additionalProperties": false,
            "description": "SourceFreshnessRuntimeError(unique_id: str, error: Union[str, int, NoneType], status: dbt.contracts.results.FreshnessErrorEnum)"
        },
        "SourceFreshnessOutput": {
            "type": "object",
            "required": [
                "unique_id",
                "max_loaded_at",
                "snapshotted_at",
                "max_loaded_at_time_ago_in_s",
                "status",
                "criteria",
                "adapter_response",
                "timing",
                "thread_id",
                "execution_time"
            ],
            "properties": {
                "unique_id": {
                    "type": "string"
                },
                "max_loaded_at": {
                    "type": "string",
                    "format": "date-time"
                },
                "snapshotted_at": {
                    "type": "string",
                    "format": "date-time"
                },
                "max_loaded_at_time_ago_in_s": {
                    "type": "number"
                },
                "status": {
                    "type": "string",
                    "enum": ["pass", "warn", "error", "runtime error"]
                },
                "criteria": {
                    "$ref": "#/definitions/FreshnessThreshold"
                },
                "adapter_response": {
                    "type": "object"
                },
                "timing": {
                    "type": "array",
                    "items": {
                        "$ref": "#/definitions/TimingInfo"
                    }
                },
                "thread_id": {
                    "type": "string"
                },
                "execution_time": {
                    "type": "number"
                }
            },
            "additionalProperties": false,
            "description": "SourceFreshnessOutput(unique_id: str, max_loaded_at: datetime.datetime, snapshotted_at: datetime.datetime, max_loaded_at_time_ago_in_s: float, status: dbt.contracts.results.FreshnessStatus, criteria: dbt.contracts.graph.unparsed.FreshnessThreshold, adapter_response: Dict[str, Any], timing: List[dbt.contracts.results.TimingInfo], thread_id: str, execution_time: float)"
        },
        "Time": {
            "type": "object",
            "required": [],
            "properties": {
                "count": {
                    "oneOf": [
                        {
                            "type": "integer"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "period": {
                    "oneOf": [
                        {
                            "type": "string",
                            "enum": ["minute", "hour", "day"]
                        },
                        {
                            "type": "null"
                        }
                    ]
                }
            },
            "additionalProperties": false,
            "description": "Time(count: Optional[int] = None, period: Optional[dbt.contracts.graph.unparsed.TimePeriod] = None)"
        },
        "TimingInfo": {
            "type": "object",
            "required": ["name"],
            "properties": {
                "name": {
                    "type": "string"
                },
                "started_at": {
                    "oneOf": [
                        {
                            "type": "string",
                            "format": "date-time"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "completed_at": {
                    "oneOf": [
                        {
                            "type": "string",
                            "format": "date-time"
                        },
                        {
                            "type": "null"
                        }
                    ]
                }
            },
            "additionalProperties": false,
            "description": "TimingInfo(name: str, started_at: Optional[datetime.datetime] = None, completed_at: Optional[datetime.datetime] = None)"
        },
        "ExternalTable": {
            "type": "object",
            "required": [],
            "properties": {
                "location": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "file_format": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "row_format": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "tbl_properties": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "partitions": {
                    "oneOf": [
                        {
                            "type": "array",
                            "items": {
                                "type": "string"
                            }
                        },
                        {
                            "type": "array",
                            "items": {
                                "$ref": "#/definitions/ExternalPartition"
                            }
                        },
                        {
                            "type": "null"
                        }
                    ]
                }
            },
            "additionalProperties": true,
            "description": "ExternalTable(_extra: Dict[str, Any] = <factory>, location: Optional[str] = None, file_format: Optional[str] = None, row_format: Optional[str] = None, tbl_properties: Optional[str] = None, partitions: Union[List[str], List[dbt.contracts.graph.unparsed.ExternalPartition], NoneType] = None)"
        },
        "ExternalPartition": {
            "type": "object",
            "required": [],
            "properties": {
                "name": {
                    "type": "string",
                    "default": ""
                },
                "description": {
                    "type": "string",
                    "default": ""
                },
                "data_type": {
                    "type": "string",
                    "default": ""
                },
                "meta": {
                    "type": "object",
                    "default": {}
                }
            },
            "additionalProperties": true,
            "description": "ExternalPartition(_extra: Dict[str, Any] = <factory>, name: str = '', description: str = '', data_type: str = '', meta: Dict[str, Any] = <factory>)"
        },
        "SourceConfig": {
            "type": "object",
            "required": [],
            "properties": {
                "enabled": {
                    "type": "boolean",
                    "default": true
                }
            },
            "additionalProperties": true,
            "description": "SourceConfig(_extra: Dict[str, Any] = <factory>, enabled: bool = True)"
        },
        "Macro": {
            "type": "object",
            "required": [
                "name",
                "resource_type",
                "package_name",
                "path",
                "original_file_path",
                "unique_id",
                "macro_sql"
            ],
            "properties": {
                "name": {
                    "type": "string"
                },
                "resource_type": {
                    "type": "string",
                    "enum": ["macro"]
                },
                "package_name": {
                    "type": "string"
                },
                "path": {
                    "type": "string"
                },
                "original_file_path": {
                    "type": "string"
                },
                "unique_id": {
                    "type": "string"
                },
                "macro_sql": {
                    "type": "string"
                },
                "depends_on": {
                    "$ref": "#/definitions/MacroDependsOn",
                    "default": {
                        "macros": []
                    }
                },
                "description": {
                    "type": "string",
                    "default": ""
                },
                "meta": {
                    "type": "object",
                    "default": {}
                },
                "docs": {
                    "$ref": "#/definitions/Docs",
                    "default": {
                        "show": true,
                        "node_color": null
                    }
                },
                "patch_path": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "arguments": {
                    "type": "array",
                    "items": {
                        "$ref": "#/definitions/MacroArgument"
                    },
                    "default": []
                },
                "created_at": {
                    "type": "number",
                    "default": 1682075346.505871
                },
                "supported_languages": {
                    "oneOf": [
                        {
                            "type": "array",
                            "items": {
                                "type": "string",
                                "enum": ["python", "sql"]
                            }
                        },
                        {
                            "type": "null"
                        }
                    ]
                }
            },
            "additionalProperties": false,
            "description": "Macro(name: str, resource_type: dbt.node_types.NodeType, package_name: str, path: str, original_file_path: str, unique_id: str, macro_sql: str, depends_on: dbt.contracts.graph.nodes.MacroDependsOn = <factory>, description: str = '', meta: Dict[str, Any] = <factory>, docs: dbt.contracts.graph.unparsed.Docs = <factory>, patch_path: Optional[str] = None, arguments: List[dbt.contracts.graph.unparsed.MacroArgument] = <factory>, created_at: float = <factory>, supported_languages: Optional[List[dbt.node_types.ModelLanguage]] = None)"
        },
        "MacroArgument": {
            "type": "object",
            "required": ["name"],
            "properties": {
                "name": {
                    "type": "string"
                },
                "type": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "description": {
                    "type": "string",
                    "default": ""
                }
            },
            "additionalProperties": false,
            "description": "MacroArgument(name: str, type: Optional[str] = None, description: str = '')"
        },
        "Documentation": {
            "type": "object",
            "required": [
                "name",
                "resource_type",
                "package_name",
                "path",
                "original_file_path",
                "unique_id",
                "block_contents"
            ],
            "properties": {
                "name": {
                    "type": "string"
                },
                "resource_type": {
                    "type": "string",
                    "enum": ["doc"]
                },
                "package_name": {
                    "type": "string"
                },
                "path": {
                    "type": "string"
                },
                "original_file_path": {
                    "type": "string"
                },
                "unique_id": {
                    "type": "string"
                },
                "block_contents": {
                    "type": "string"
                }
            },
            "additionalProperties": false,
            "description": "Documentation(name: str, resource_type: dbt.node_types.NodeType, package_name: str, path: str, original_file_path: str, unique_id: str, block_contents: str)"
        },
        "Exposure": {
            "type": "object",
            "required": [
                "name",
                "resource_type",
                "package_name",
                "path",
                "original_file_path",
                "unique_id",
                "fqn",
                "type",
                "owner"
            ],
            "properties": {
                "name": {
                    "type": "string"
                },
                "resource_type": {
                    "type": "string",
                    "enum": ["exposure"]
                },
                "package_name": {
                    "type": "string"
                },
                "path": {
                    "type": "string"
                },
                "original_file_path": {
                    "type": "string"
                },
                "unique_id": {
                    "type": "string"
                },
                "fqn": {
                    "type": "array",
                    "items": {
                        "type": "string"
                    }
                },
                "type": {
                    "type": "string",
                    "enum": [
                        "dashboard",
                        "notebook",
                        "analysis",
                        "ml",
                        "application"
                    ]
                },
                "owner": {
                    "$ref": "#/definitions/Owner"
                },
                "description": {
                    "type": "string",
                    "default": ""
                },
                "label": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "maturity": {
                    "oneOf": [
                        {
                            "type": "string",
                            "enum": ["low", "medium", "high"]
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "meta": {
                    "type": "object",
                    "default": {}
                },
                "tags": {
                    "type": "array",
                    "items": {
                        "type": "string"
                    },
                    "default": []
                },
                "config": {
                    "$ref": "#/definitions/ExposureConfig",
                    "default": {
                        "enabled": true
                    }
                },
                "unrendered_config": {
                    "type": "object",
                    "default": {}
                },
                "url": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "depends_on": {
                    "$ref": "#/definitions/DependsOn",
                    "default": {
                        "macros": [],
                        "nodes": []
                    }
                },
                "refs": {
                    "type": "array",
                    "items": {
                        "$ref": "#/definitions/RefArgs"
                    },
                    "default": []
                },
                "sources": {
                    "type": "array",
                    "items": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        }
                    },
                    "default": []
                },
                "metrics": {
                    "type": "array",
                    "items": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        }
                    },
                    "default": []
                },
                "created_at": {
                    "type": "number",
                    "default": 1682075346.50651
                }
            },
            "additionalProperties": false,
            "description": "Exposure(name: str, resource_type: dbt.node_types.NodeType, package_name: str, path: str, original_file_path: str, unique_id: str, fqn: List[str], type: dbt.contracts.graph.unparsed.ExposureType, owner: dbt.contracts.graph.unparsed.Owner, description: str = '', label: Optional[str] = None, maturity: Optional[dbt.contracts.graph.unparsed.MaturityType] = None, meta: Dict[str, Any] = <factory>, tags: List[str] = <factory>, config: dbt.contracts.graph.model_config.ExposureConfig = <factory>, unrendered_config: Dict[str, Any] = <factory>, url: Optional[str] = None, depends_on: dbt.contracts.graph.nodes.DependsOn = <factory>, refs: List[dbt.contracts.graph.nodes.RefArgs] = <factory>, sources: List[List[str]] = <factory>, metrics: List[List[str]] = <factory>, created_at: float = <factory>)"
        },
        "Owner": {
            "type": "object",
            "required": [],
            "properties": {
                "email": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "name": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                }
            },
            "additionalProperties": true,
            "description": "Owner(_extra: Dict[str, Any] = <factory>, email: Optional[str] = None, name: Optional[str] = None)"
        },
        "ExposureConfig": {
            "type": "object",
            "required": [],
            "properties": {
                "enabled": {
                    "type": "boolean",
                    "default": true
                }
            },
            "additionalProperties": true,
            "description": "ExposureConfig(_extra: Dict[str, Any] = <factory>, enabled: bool = True)"
        },
        "Metric": {
            "type": "object",
            "required": [
                "name",
                "resource_type",
                "package_name",
                "path",
                "original_file_path",
                "unique_id",
                "fqn",
                "description",
                "label",
                "calculation_method",
                "expression",
                "filters",
                "time_grains",
                "dimensions"
            ],
            "properties": {
                "name": {
                    "type": "string"
                },
                "resource_type": {
                    "type": "string",
                    "enum": ["metric"]
                },
                "package_name": {
                    "type": "string"
                },
                "path": {
                    "type": "string"
                },
                "original_file_path": {
                    "type": "string"
                },
                "unique_id": {
                    "type": "string"
                },
                "fqn": {
                    "type": "array",
                    "items": {
                        "type": "string"
                    }
                },
                "description": {
                    "type": "string"
                },
                "label": {
                    "type": "string"
                },
                "calculation_method": {
                    "type": "string"
                },
                "expression": {
                    "type": "string"
                },
                "filters": {
                    "type": "array",
                    "items": {
                        "$ref": "#/definitions/MetricFilter"
                    }
                },
                "time_grains": {
                    "type": "array",
                    "items": {
                        "type": "string"
                    }
                },
                "dimensions": {
                    "type": "array",
                    "items": {
                        "type": "string"
                    }
                },
                "timestamp": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "window": {
                    "oneOf": [
                        {
                            "$ref": "#/definitions/MetricTime"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "model": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "model_unique_id": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "meta": {
                    "type": "object",
                    "default": {}
                },
                "tags": {
                    "type": "array",
                    "items": {
                        "type": "string"
                    },
                    "default": []
                },
                "config": {
                    "$ref": "#/definitions/MetricConfig",
                    "default": {
                        "enabled": true,
                        "group": null
                    }
                },
                "unrendered_config": {
                    "type": "object",
                    "default": {}
                },
                "sources": {
                    "type": "array",
                    "items": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        }
                    },
                    "default": []
                },
                "depends_on": {
                    "$ref": "#/definitions/DependsOn",
                    "default": {
                        "macros": [],
                        "nodes": []
                    }
                },
                "refs": {
                    "type": "array",
                    "items": {
                        "$ref": "#/definitions/RefArgs"
                    },
                    "default": []
                },
                "metrics": {
                    "type": "array",
                    "items": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        }
                    },
                    "default": []
                },
                "created_at": {
                    "type": "number",
                    "default": 1682075346.507186
                },
                "group": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                }
            },
            "additionalProperties": false,
            "description": "Metric(name: str, resource_type: dbt.node_types.NodeType, package_name: str, path: str, original_file_path: str, unique_id: str, fqn: List[str], description: str, label: str, calculation_method: str, expression: str, filters: List[dbt.contracts.graph.unparsed.MetricFilter], time_grains: List[str], dimensions: List[str], timestamp: Optional[str] = None, window: Optional[dbt.contracts.graph.unparsed.MetricTime] = None, model: Optional[str] = None, model_unique_id: Optional[str] = None, meta: Dict[str, Any] = <factory>, tags: List[str] = <factory>, config: dbt.contracts.graph.model_config.MetricConfig = <factory>, unrendered_config: Dict[str, Any] = <factory>, sources: List[List[str]] = <factory>, depends_on: dbt.contracts.graph.nodes.DependsOn = <factory>, refs: List[dbt.contracts.graph.nodes.RefArgs] = <factory>, metrics: List[List[str]] = <factory>, created_at: float = <factory>, group: Optional[str] = None)"
        },
        "MetricFilter": {
            "type": "object",
            "required": ["field", "operator", "value"],
            "properties": {
                "field": {
                    "type": "string"
                },
                "operator": {
                    "type": "string"
                },
                "value": {
                    "type": "string"
                }
            },
            "additionalProperties": false,
            "description": "MetricFilter(field: str, operator: str, value: str)"
        },
        "MetricTime": {
            "type": "object",
            "required": [],
            "properties": {
                "count": {
                    "oneOf": [
                        {
                            "type": "integer"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "period": {
                    "oneOf": [
                        {
                            "type": "string",
                            "enum": ["day", "week", "month", "year"]
                        },
                        {
                            "type": "null"
                        }
                    ]
                }
            },
            "additionalProperties": false,
            "description": "MetricTime(count: Optional[int] = None, period: Optional[dbt.contracts.graph.unparsed.MetricTimePeriod] = None)"
        },
        "MetricConfig": {
            "type": "object",
            "required": [],
            "properties": {
                "enabled": {
                    "type": "boolean",
                    "default": true
                },
                "group": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                }
            },
            "additionalProperties": true,
            "description": "MetricConfig(_extra: Dict[str, Any] = <factory>, enabled: bool = True, group: Optional[str] = None)"
        },
        "Group": {
            "type": "object",
            "required": [
                "name",
                "resource_type",
                "package_name",
                "path",
                "original_file_path",
                "unique_id",
                "owner"
            ],
            "properties": {
                "name": {
                    "type": "string"
                },
                "resource_type": {
                    "type": "string",
                    "enum": ["group"]
                },
                "package_name": {
                    "type": "string"
                },
                "path": {
                    "type": "string"
                },
                "original_file_path": {
                    "type": "string"
                },
                "unique_id": {
                    "type": "string"
                },
                "owner": {
                    "$ref": "#/definitions/Owner"
                }
            },
            "additionalProperties": false,
            "description": "Group(name: str, resource_type: dbt.node_types.NodeType, package_name: str, path: str, original_file_path: str, unique_id: str, owner: dbt.contracts.graph.unparsed.Owner)"
        }
    },
    "$schema": "http://json-schema.org/draft-07/schema#",
    "$id": "https://schemas.getdbt.com/dbt/manifest/v9.json"
}
